// extracted by mini-css-extract-plugin
export default {"theme1":"CheckMarkIcon_theme1__FwbrV","theme2":"CheckMarkIcon_theme2__BumG9","theme3":"CheckMarkIcon_theme3__RY0up","theme4":"CheckMarkIcon_theme4__ZztnL"};